<template>

  <div>

    <!-- Header -->
    <template v-if="matching && matching.total">

      <div class="flex flex-col py-4">

        <div class="py-4">
          <h3>{{ matching.total }} Matching Products</h3>
        </div>

        <div class="mb-6">

          <div class="flex flex-wrap items-center">

            <div class="flex-auto mr-2">
              <MatchingPaging v-if="matching.paging" :paging="matching.paging" @loadPage="loadPage"></MatchingPaging>
            </div>

            <div v-if="data.actions && data.actions.next">
              <button
                @click.once="applyAction(data.actions.next)"
                class="text-xs bg-grey-lightest rounded p-2 hover:bg-grey-light whitespace-no-wrap"
                type="button">Continue &rarr;</button>
            </div>

          </div>

        </div>

      </div>

      <div class="divider-border m-0 bg-grey-lighter"></div>

    </template>

    <!-- Records -->
    <template v-if="matching">

      <div v-for="record in matching.records" :key="record.recordid" class="divided">

        <div class="py-16">

          <div v-if="record.images && record.images.length" class="img-with-animation-wrap center pb-2 pt-4 pr-8" style="width: 210px;" >
            <div
              class="bg-cover img-with-animation skip-lazy animated-in "
              style="opacity:1;width:100%;height:40px;"
              :style="'background-image:url(' + record.images[0].src + ');'"
              data-shadow="none"
              data-shadow-direction="middle"
              data-delay="0"
              data-animation="fade-in"
              draggable="false"
             ></div>
          </div>

          <div>

            <h2 v-if="record.title" class="py-1 pt-4 mb-4 xs:text-lg break-words">{{ record.title }}</h2>

            <div v-if="record.actions" class="flex flex-wrap">

              <template v-if="record.actions.add_static">

                <button v-if="record.already_added" type="button" class="text-white cursor-default uppercase inline-block" style="outline:none;position:relative;top:-3px;line-height:20px;letter-spacing:2px;opacity:.87;font-family:Jura;font-weight:600;font-size:12px;background-color:#004f45;padding:4px 33px;margin:0 4px 4px 0;">
                  <span>Added</span>
                  <i class="fa fa-check"></i>
                </button>

                <button v-else @click="addRecord(record.actions.add_static)" type="button" class="nectar-button cursor-pointer small has-icon mr-1 mb-1">
                  <i class="fa fa-briefcase"></i>
                  <span>Add to Project</span>
                </button>

              </template>

              <button
                v-if="record.actions.view"
                @click="applyAction(record.actions.view)"
                type="button" class="nectar-button cursor-pointer small has-icon mr-1 mb-1"
              >
                <i class="fa fa-eye"></i>
                <span>View Details</span>
              </button>

            </div>
          </div>

        </div>

      </div>

      <div class="pt-16 pb-4 md:pb-16">

        <div class="mb-6">

          <div class="flex flex-wrap items-center">

            <div class="flex-auto mr-2">
              <MatchingPaging v-if="matching.paging" :paging="matching.paging" @loadPage="loadPage"></MatchingPaging>
            </div>

            <div v-if="data.actions && data.actions.next">
              <button
                @click="applyAction(data.actions.next)"
                class="text-xs bg-grey-lightest rounded p-2 hover:bg-grey-light whitespace-no-wrap"
                type="button">Continue &rarr;</button>
            </div>

          </div>

        </div>

      </div>

    </template>

  </div>

</template>

<script>

import MatchingPaging from '@/components/MatchingPaging.vue'

import { mapState, mapActions } from 'vuex'

export default {

  name: 'VaRecords',

  props: {

    data: { type: Object }

  },

  components: {

    MatchingPaging

  },

  computed: {

    ...mapState(['stateid', 'matching'])

  },

  // data() {
  //   return {
  //     showRecordModal: false
  //   }
  // },

  created() {

    this.loadPage(1);

  },

  methods: {

    ...mapActions(['loadCart', 'loadMatching']),

    applyAction(action) {

      this.$emit('applyAction', action);

    },

    loadPage(page) {

      this.loadMatching(page || 1);

    },

    addRecord(action) {

      this.$store.dispatch('applyAction', action)

        .then(() => {

          this.loadCart(this.stateid);

        });

    }
  }
}
</script>
